import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useCustomSnackbar } from '../../../../../../hooks/useCustomEnqueueSnackbar';
import { CustomMUIButton } from '../../../../buttons/CustomMUIButton';
import { ButtonClassNames } from '../../../../../../models/Common';
import { regularPaymentsApi } from '../../../../../../services/apiServices/user/regularPayments';
import { getErrorMessage } from '../../../../../../utils';

interface DeleteEmailProps {
  handleClose: () => void;
}

export const DeleteAutoReplenishmentEmail: FC<DeleteEmailProps> = ({ handleClose }) => {
  const { t } = useTranslation();
  const { customEnqueueSnackbar } = useCustomSnackbar();
  const [deleteRegularPaymentEmail, { isLoading }] = regularPaymentsApi.useDeleteRegularPaymentEmailMutation();

  const handleDeleteEmail = async () => {
    try {
      await deleteRegularPaymentEmail('')
        .unwrap()
        .then(() => {
          customEnqueueSnackbar(t('snackbar.autoReplenishmentDeleteEmail'), 'warning');
          customEnqueueSnackbar(t('snackbar.regularPaymentDisabled'), 'warning');
          handleClose();
        });
    } catch (err) {
      const message = getErrorMessage(err);
      customEnqueueSnackbar(message, 'error');
      handleClose();
    }
  };

  return (
    <div className="modals">
      <div className="modals__header">
        <article className="modals__header__title">{t('accountSettings.delete?')}</article>
        <p className="modals__header__description">{t('accountSettings.regularPaymentDeleteEmailWarning')}</p>
      </div>
      <div className="modals__btn-group">
        <CustomMUIButton
          label={t('buttons.proceed')}
          handleClick={handleDeleteEmail}
          className={ButtonClassNames.PrimaryFulfilled}
          isBold
          isLoading={isLoading}
        />
        <CustomMUIButton
          label={t('buttons.decline')}
          handleClick={handleClose}
          className={ButtonClassNames.SecondaryOutlined}
          isBold
          isDisabled={isLoading}
        />
      </div>
    </div>
  );
};
